import TextContainer from "@client/content/Containers/Text/container";
import withStyleSheets from "@client/content/Containers/withStyleSheets";
import countTo from "@client/content/hocs/countTo";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type CountToOptions } from "@client/lib/jquery/countTo";
import classnames from "classnames";
import * as React from "react";

import "./style.less";

export type CountersComponentProps = RootContainerProps & {
  appendText: string;
  horizontalAlign: string;
  countToOptions: CountToOptions;
  prependText: string;
};

const CountToSpan = countTo<HTMLSpanElement>("span");

const CounterContainer = withStyleSheets<React.HTMLProps<HTMLDivElement>>((props) => <div {...props} />, ["text"]);

export default (props: CountersComponentProps) => (
  <TextContainer className="wsc_content_counter" {...getContainerProps(props)}>
    {/* <ContentTextStyle id={props.id} textSubSelector=".counter-item .counter" /> */}

    <div className="counter-item">
      <CounterContainer {...getEntityRef(props)} className={classnames("counter")} textSubSelector=".counter">
        {!!props.prependText && (
          <props.TextComponent
            {...getEntityRef(props)}
            toolbar={"extended"}
            prop="prependText"
            tag="span"
            html={props.prependText}
          />
        )}
        <CountToSpan countToOptions={props.countToOptions} />
        {!!props.appendText && (
          <props.TextComponent
            {...getEntityRef(props)}
            toolbar={"extended"}
            prop="appendText"
            tag="span"
            html={props.appendText}
          />
        )}
      </CounterContainer>
    </div>
  </TextContainer>
);
